// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"248f2c3a","977":"0d34b9b9"}[chunkId] + ".chunk.js";
};